import React from 'react'
import PoliMi from '../../../assets/images/PoliMi.png'
import Cattolica from '../../../assets/images/cattolica-logo.png'
import Azimut from '../../../assets/images/azimut.png'
import { Grid, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export const PartnersBlock = () => {
  const { t, i18n } = useTranslation('translations')

  return (
    <Grid item xs={12} lg={10}>
      <Typography style={{ fontSize: '0.875rem', fontWeight: 700, color: '#000000', marginBottom: '1.5rem' }}>{t('booking.paymentInfo.collaborateWithUs')}:</Typography>
      <div className="w-full overflow-auto flex items-center lg:flex-wrap lg:overflow-hidden" style={{gap: '2rem'}}>
        <img src={PoliMi} className="w-3/12 object-contain m-" style={{ maxHeight: '64px' }} />
        <img src={Cattolica} className="w-3/12 object-contain" style={{ maxHeight: '64px' }} />
        <img src={Azimut} className="w-3/12 object-contain" style={{ maxHeight: '64px' }} />
      </div>
    </Grid>
  )
}